import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const INTAKE_ASSESSMENT_PERMISSIONS = {
  READ: 'intake_assessment:read',
  CREATE: 'intake_assessment:create',
  UPDATE: 'intake_assessment:update',
  REVIEW: 'intake_assessment:review',
} as const;

export function canSeeIntakeAssessmentMenu(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, INTAKE_ASSESSMENT_PERMISSIONS.READ);
}
